import { render, staticRenderFns } from "./DocumentContentListView.vue?vue&type=template&id=982a6cea"
import script from "./DocumentContentListView.vue?vue&type=script&lang=js"
export * from "./DocumentContentListView.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentListView.vue?vue&type=style&index=0&id=982a6cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports